// gtm.js
import TagManager from "react-gtm-module";
const gtmId = "GTM-5LW8VTS"; // Replace with your GTM ID
export const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};